import { checkSigned } from "../../Sign/utils/fileSignUtils";

export const validateFiles = (files, config, readonly, currentUserCompanyInn) => {
  // @ts-expect-error - b TODO: fix
  if (window?.skipDocsValidation || readonly || config?.readonly) {
    return true;
  }

  const hasFiles = files?.length > 0;
  // Проверяем подписан ли каждый файл, если файлы есть
  const isSigned =
    hasFiles && files?.every((file) => checkSigned(file, config.needCoSign, currentUserCompanyInn));

  // Если файлы требуются, но не предоставлены, возвращаем ошибку
  if (config.required && !hasFiles) return "Необходимо вложить документ";

  // Если требуется подпись, но файлы не подписаны (или требуется повторная подпись), возвращаем ошибку
  if (config.sign && !isSigned && hasFiles) return "Необходимо подписание.";

  // Во всех остальных случаях возвращаем true
  return true;
};
